<template>
  <div>
    <section-definition :title="page.title"></section-definition>
    <v-container fluid>

      <view-grade
          v-if="gradedLead"
          :graded_lead="gradedLead"
          :show-x="false"
      ></view-grade>

      <v-layout wrap v-else>
        <v-flex grow></v-flex>
        <v-flex shrink> Sorry, the requested grade couldn't be found.  Please contact the help if this issue continues</v-flex>
        <v-flex grow></v-flex>
      </v-layout>

    </v-container>
  </div>
</template>





<script>

   import viewGrade from '../components/viewGrade.vue';
   import data_getters from '../mixins/data_getters'


   export default {
      components:{
         viewGrade
      },
      mixins: [data_getters],
      data() {
         return {
            gradedLead1: null,
            gradedLead: null,
            page: {
               title: "View Graded Lead Details",
            },
         };
      },
      async created(){

         let tmp  = await this.get_graded_leads({_id: this.$route.params.grade_id, get_player_data: 'percent'});
         console.log(tmp)
         this.gradedLead = tmp[0];

      }
   };
</script>
